export default class ProcessFlowModel {
  id!: number;

  nome!: string;

  flagAtivo!: number;

  tipoVisualizacao!: number;
}
